export default "__VITE_ASSET__6aOObgLi__"